module.exports = __webpack_public_path__ + "img/tab-chat-hover.7431f34c.svg";